module.exports = __webpack_public_path__ + "img/7_wind.01fa6e8a.jpg";